import clsx from 'clsx';
import React, { memo, useState } from 'react';

import { IConfig } from '../../../hooks/useSortableData';
import Typography from '../typography';
import { ITableColumn, ITableOptions } from '.';

interface IProps {
  options?: ITableOptions | null;
  columns: ITableColumn[];
  sortConfig: IConfig | null;
  requestSort: Function;
  className?: string;
}

// This is the same code, but extracted out to be reused elsewhere
const TableHeader = ({
  columns,
  sortConfig,
  requestSort,
  className = '',
  options = undefined,
}: IProps) => {
  const [hoveredColumnKey, setHoveredColumnKey] = useState('');

  const getColumnHeaderTextOpacity = (column: ITableColumn) => {
    if (hoveredColumnKey === column.key || sortConfig?.key === column.key) {
      return 'opacity-100';
    }

    return 'opacity-0';
  };

  const renderColumnCell = (column: ITableColumn) => {
    const content = [
      <span
        key={`${column.headerName}-1`}
        className={clsx(
          getColumnHeaderTextOpacity(column),
          sortConfig?.key === column.key &&
            sortConfig?.direction === 'descending' &&
            'rotate-180',
          'material-icons-outlined transition'
        )}
        id="column-arrow"
      >
        arrow_drop_up
      </span>,
      <Typography
        key={`${column.headerName}-2`}
        className="break-words !font-semibold text-gray-100"
        style={{ fontSize: 12 }}
      >
        {column.headerName}
      </Typography>,
    ];

    return (
      <div
        className={clsx(
          column.alignment === 'right' ? 'justify-end' : ' justify-start',
          'flex w-full items-center'
        )}
      >
        {column.alignment === 'right' ? content : content.reverse()}
      </div>
    );
  };

  if (!options?.hideHeader) {
    return (
      <thead className={clsx('h-11 w-full bg-gray-10', className)}>
        <tr className="w-full">
          {columns.map((column) => (
            <th
              key={column.key}
              className={clsx(
                sortConfig?.key !== column.key &&
                  hoveredColumnKey === column.key &&
                  column.headerName &&
                  'hover:opacity-50',
                ' max-w-[1px] select-none'
              )}
              onMouseEnter={() => setHoveredColumnKey(column.key)}
              onMouseLeave={() => setHoveredColumnKey('')}
            >
              {column.headerName ? (
                <button
                  className="w-full p-2"
                  type="button"
                  onClick={() => {
                    if (column.headerName) {
                      requestSort(column.key);
                    }
                  }}
                >
                  {renderColumnCell(column)}
                </button>
              ) : null}
            </th>
          ))}
        </tr>
      </thead>
    );
  }

  return null;
};

export default memo(TableHeader);
